import { render, staticRenderFns } from "./NachbestellungSheet.vue?vue&type=template&id=68523a98"
import script from "./NachbestellungSheet.vue?vue&type=script&lang=ts"
export * from "./NachbestellungSheet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports